"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tremosine-sul-garda": {
    "0b586079": [{
      "hkey": "109e1ff3",
      "slug": "pieve-mezzema",
      "name": "Pieve-Mezzema",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "109e1ff3",
      "slug": "pieve-mezzema",
      "name": "Pieve-Mezzema",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50d3ffba": [{
      "hkey": "99e4c38c",
      "slug": "ustecchio",
      "name": "Ustecchio",
      "primary": true,
      "skipSearch": false
    }],
    "ustechio": [{
      "hkey": "99e4c38c",
      "slug": "ustecchio",
      "name": "Ustecchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;